"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
var Interaction_1 = require("./Interaction");
var Introspection_1 = require("./Introspection");
var Notification_1 = require("./Notification");
/**
 * the top level subscription type
 */
var Subscription = /** @class */ (function (_super) {
    __extends(Subscription, _super);
    function Subscription() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Subscription";
        _this.interact = function (config) { return _this.push(function (registry) {
            var entity = new Interaction_1.Interaction();
            config(entity);
            return "interact { " + entity.render(registry) + " }";
        }); };
        _this.notify = function (config) { return _this.push(function (registry) {
            var entity = new Notification_1.Notification();
            config(entity);
            return "notify { " + entity.render(registry) + " }";
        }); };
        /**
         * Container element for all introspect sensor fields
         */
        _this.introspect = function (config) { return _this.push(function (registry) {
            var entity = new Introspection_1.Introspection();
            config(entity);
            return "introspect { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Subscription;
}(Array));
exports.Subscription = Subscription;
//# sourceMappingURL=Subscription.js.map